import { Link } from "gatsby";
import React from "react";
import { useEffect } from "react";

export const ServiceCard = (data) => {


  const { name, text, svg, link, key } = data.content;
  return (
    <div
      className="col-12 col-md-6 col-lg-3"
      data-aos="fade-up"
      data-aos-anchor-placement="bottom-bottom"
      data-aos-offset="-200"
      data-aos-duration="1000"
      data-aos-once="false"
    >
      <Link to={link}>
        <div
          className={`card card1 py-4 px-3 load-hidden border-0 text-center ${key}`}
        >
          <img
            src={svg}
            alt={name}
            className="card-img-top mx-auto mt-4 mb-3"
          />
          <h6>{name}</h6>
          <p>{text}</p>
        </div>
      </Link>
    </div>
  );
};
